import {
  Flex,
  Table,
  Checkbox,
  Tbody,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  CheckboxGroup,
  Stack,
  Image,
  Alert,
  AlertIcon,
  Box,
  VStack,
  HStack,
  Divider,
} from "@chakra-ui/react";
import React, { useContext } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import { useAuthContext } from "hooks/useAuthContext";
import { useState, useEffect } from "react";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import Amazon from "assets/img/amazon.ico";
import Flipkart from "assets/img/flipkart.ico";
import Snapdeal from "assets/img/snapdeal.ico";
import Meesho from "assets/img/meesho.ico";
import Glowroad from "assets/img/glowroad.ico";
import freeup from "assets/img/freeup.ico";
import Shopsy from "assets/img/shopsy.ico"
import Youtube from "assets/img/youtube.ico"
import Dailymotion from "assets/img/dailymotion.ico"
import JioMart from "assets/img/jiomart.ico"
import IndiaMart from "assets/img/indiamart.ico"
import _, { filter } from "lodash";
import { FaExpand } from "react-icons/fa";
import { CgExpand } from "react-icons/cg";
import { MdExpandMore } from "react-icons/md";
import ExpandedComponent from "./ExpandedComponent";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { Tooltip } from "react-bootstrap";


export default function CheckTable() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { user } = useAuthContext();
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const isAdmin = userInfo?.message?.isAdmin || false;
  const [keywords, setKeywords] = useState([]);
  const [inputKeyword, setInputKeyword] = useState("");
  const [inputManu, setInputManu] = useState("");
  const [inputBrand, setInputBrand] = useState("");
  const [inputError, setInputError] = useState(false);
  const [platforms, setPlatforms] = useState([]);
  const [selectedPlatforms, setSelectedPlatforms] = useState([]); // For new entries
  const [editSelectedPlatforms, setEditSelectedPlatforms] = useState({}); // For edit mode per row
  const [insertKeywords, setInsertKeyword] = useState([]);
  const [editMode, setEditMode] = useState({});
  const [uniqueKeywords, setUniqueKeywords] = useState([]);
  const [successAlert, setSuccesAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [expandedKeyword, setExpandedKeyword] = useState();
  const [groupedByIdKeywords, setGroupedByIdKeywords] = useState();
  const [selectedSearchTerms, setSelectedSearchTerms] = useState([]);

  const getPlatformIcon = (platformId) => {
    switch (platformId) {
      case 1:
        return Amazon;
      case 2:
        return Flipkart;
      case 3:
        return Snapdeal;
      case 4:
        return Meesho;
      case 5:
        return Glowroad;
      case 6:
        return Shopsy;
      case 7:
        return freeup;
      case 8:
        return IndiaMart;
      case 9:
        return Youtube
      case 10:
        return Dailymotion;
      case 11:
        return JioMart;

    }
  };

  const HandlePlatformsRender = ({ platforms, row }) => {
    return platforms.map((it, index) => {
      // const isGrayscale = it.pmp_status === 2 || it.pmp_status === 3;
      const platformIcon = getPlatformIcon(it.pf_id); // Get icon dynamically
      return (
        <Image
          boxSize="16px"
          objectFit="cover"
          src={platformIcon} // Use the returned icon
          alt={`Platform ${it.pf_id}`}
          mr="5px"
          title={it.name}
        />
      );
    }
    );
  };

  const handleSuccessAlert = async (alertMessage) => {
    setSuccesAlert(alertMessage);
    setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
  };
  const handleFailureAlert = async (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert("");
    }, 5000);
  };

  const fetchKeywords = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/keyword/getKeywords/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
        }),
      });

      const json = await response.json();

      if (response.ok) {
        setKeywords(json);
        setInsertKeyword([]);
      } else if (response.status === 400) {
        handleFailureAlert("Error getting keywords");
      }
    } catch (e) {
      handleFailureAlert("Error getting keywords");
    }
  };

  const fetchPlatforms = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/platforms/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const json = await response.json();
      if (response.ok) {
        setPlatforms(json);
      } else if (response.status === 400) {
        handleFailureAlert("Error Fetching Platforms");
      }
    } catch (e) {
      handleFailureAlert("Error Fetching Platforms");
    }
  };

  const handleSearch = async (text) => {
    try {
      if (text) {
        const filtered = keywords.filter(
          (item) =>
            item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
            item.manufacturer?.toLowerCase().includes(text?.toLowerCase()) ||
            item.brand?.toLowerCase().includes(text?.toLowerCase())
        );
        setKeywords(filtered);
      } else {
        setKeywords(keywords || []);
      }
    } catch (e) {
      console.error("error in search", e);
    }
  };

  useEffect(() => {
    fetchKeywords();
    fetchPlatforms();
  }, [userInfo?.message?.result.id]);

  const headings = [
    "SR NO.",
    "KEYWORDS",
    "MANUFACTURER",
    "BRAND",
    "PLATFORM",
    "",
  ];

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const handleTempInsertKeyword = async () => {
    try {
      if (
        inputBrand === "" ||
        inputKeyword === "" ||
        inputManu === "" ||
        selectedPlatforms.length === 0
      ) {
        setInputError(true);
        return;
      } else if (inputBrand !== "" && inputKeyword !== "" && inputManu !== "") {
        setInputError(false);
      }
      let dataToSend = {
        user_id: userInfo?.message?.result.id,
        keyword: inputKeyword,
        manufacturer: inputManu,
        brand: inputBrand,
        platformIds: selectedPlatforms,
      };
      await setInsertKeyword([...insertKeywords, dataToSend]);
      await setInputManu("");
      await setInputKeyword("");
      await setInputBrand("");
      await setSelectedPlatforms([]); // Reset after adding
    } catch (err) {
      console.log(err);
    }
  };

  const insert = async (data) => {
    try {
      const response = await fetch(`${backendUrl}/api/keyword/insert`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          keywords: data,
        }),
      });

      const json = await response.json();

      if (response.ok) {
        handleSuccessAlert("Changes Saved");
        fetchKeywords();
      } else if (response.status === 400) {
        handleFailureAlert("Error in insertion");
      }
    } catch (err) {
      handleFailureAlert("Error in insertion");
    }
  };

  const handleConfirm = async () => {
    if (insertKeywords.length === 0) {
      handleSuccessAlert("No Changes to save");
      return;
    }
    insert(insertKeywords);
  };

  const handleDeleteButton = async (row) => {
    try {
      const confirm = window.confirm("Are you sure");
      if (!confirm) return;
      const response = await fetch(`${backendUrl}/api/keyword/disable`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          keyword_id: [row.keyword_id],
        }),
      });

      const json = await response.json();

      if (response.ok) {
        handleSuccessAlert("Keyword Deleted");
        fetchKeywords();
      } else if (response.status === 400) {
        handleFailureAlert("Error in deletion");
      }
    } catch (err) {
      handleFailureAlert("Error in deletion");
    }
  };

  const handleNewDeleteButton = async (row) => {
    try {
      setInsertKeyword(
        insertKeywords.filter(
          (item) =>
            item.keyword !== row.keyword ||
            item.manufacturer !== row.manufacturer ||
            item.brand !== row.brand
        )
      );
    } catch (err) {
      console.log("error in deleting", err);
    }
  };

  const handleEditButton = async (row) => {
    try {
      // Initialize the selected platforms for this row with current platforms
      const currentPlatforms = row.platforms
        .filter(
          (platform) =>
            platform.pmp_status === 1 ||
            platform.pmp_status === 2 ||
            platform.pmp_status === 3
        )
        .map((platform) => platform.pf_id);
      setEditSelectedPlatforms({
        ...editSelectedPlatforms,
        [row.keyword_id]: currentPlatforms,
      });
      setEditMode({ ...editMode, [row.keyword_id]: true });
    } catch (err) {
      console.log("error in edit button");
    }
  };

  const handleSaveEdit = async (row) => {
    try {
      const response = await fetch(`${backendUrl}/api/keyword/updatePlatform`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: row.keyword_id,
          pids: editSelectedPlatforms[row.keyword_id] || [],
        }),
      });

      const json = await response.json();

      if (response.ok) {
        handleSuccessAlert("Changes Saved");
        await fetchKeywords();
        setEditMode({ ...editMode, [row.keyword_id]: false });
        setEditSelectedPlatforms({
          ...editSelectedPlatforms,
          [row.keyword_id]: [],
        }); // Reset after save
      } else if (response.status === 400) {
        handleFailureAlert("Error in saving changes. Please try again!");
      }
    } catch (err) {
      handleFailureAlert("Error in saving changes. Please try again!");
    }
  };

  const createUniqueKeyword = () => {
    let groupedKeywordsByID = _.groupBy(keywords, "id");
    setGroupedByIdKeywords(groupedKeywordsByID);
    let filteredKeywords = Object.values(groupedKeywordsByID).map((item) => {
      const keyword_id = item[0].id;
      const keyword = item[0].name;
      const brand = item[0].brand;
      const manufacturer = item[0].manufacturer;

      const platforms = [
        ...new Map(
          item
            .filter(s => s.pst_pf_id != null) // Removes null/undefined IDs
            .map(s => [
              s.pst_pf_id,
              { pf_id: s.pst_pf_id, name: s.platform_name } // Use your actual property name for 'name'
            ])
        ).values()
      ];



      return { keyword_id, keyword, brand, manufacturer, platforms };
    });

    setUniqueKeywords(filteredKeywords);
  };

  const handleExpand = (row) => {
    if (expandedKeyword === row.keyword_id) {
      setExpandedKeyword();
    } else {
      setExpandedKeyword(row.keyword_id);
    }
  };

  useEffect(() => {
    createUniqueKeyword();
  }, [keywords]);


  const handleSearchTermSave = async (searchTerms, keywordId) => {
    try {
      const response = await fetch(`${backendUrl}/api/searchterm/insert`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          keyword_id: keywordId,
          search_terms: searchTerms
        })
      });

      if (response.ok) {
        handleSuccessAlert("Search terms saved successfully");
        fetchKeywords(); // Refresh the data
      } else {
        handleFailureAlert("Error saving search terms");
      }
    } catch (error) {
      handleFailureAlert("Error saving search terms");
    }
  };

  const handleKeywordCheck = (row) => {
    if (
      selectedSearchTerms[row.keyword_id]?.length ===
      (groupedByIdKeywords[row.keyword_id]?.length || 0)
    ) {
      setSelectedSearchTerms({ ...selectedSearchTerms, [row.keyword_id]: [] });
    } else {
      setSelectedSearchTerms({
        ...selectedSearchTerms,
        [row.keyword_id]: groupedByIdKeywords[row.keyword_id].flatMap(
          (term) => term.pst_id
        ),
      });
      // console.log("selectedSearchTerms", selectedSearchTerms);
      // console.log("groupedByIdKeywords", groupedByIdKeywords);
      // console.log("row", row.keyword_id);
    }
  };

  const handleSearchTermCheck = (keywordId, searchTermId) => {
    setSelectedSearchTerms(prev => {
      const existing = prev[keywordId] || [];
      const updated = existing.includes(searchTermId)
        ? existing.filter(id => id !== searchTermId)
        : [...existing, searchTermId];
      return { ...prev, [keywordId]: updated };
    });
  };

  const getAllSelectedPstIds = () => {
    const allSelectedPstIds = [];
    Object.keys(selectedSearchTerms).forEach((keywordId) => {
      const pstIds = selectedSearchTerms[keywordId];
      allSelectedPstIds.push(...pstIds);
    });
    return allSelectedPstIds;
  };

  // Update this function to only include selected search terms
  const getSelectedSearchTermsJson = () => {
    const selectedTermsJson = [];
    Object.keys(selectedSearchTerms).forEach((keywordId) => {
      selectedTermsJson.push(...selectedSearchTerms[keywordId]);
    });
    return selectedTermsJson.filter((term) => term !== null);
  };

  // Function to send data to the backend
  const handleSendDataForAll = async (searchType) => {
    const payload = {
      ids: getSelectedSearchTermsJson(),
      crawlType: searchType,
    };

    try {
      const response = await fetch(`${backendUrl}/api/keyword/initCrawler`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const json = await response.json();

      if (response.ok) {
        console.log("Successfully sent data:", json);
        handleSuccessAlert("Data sent successfully!");
      } else {
        handleFailureAlert("Error sending data: " + json.message);
      }
    } catch (error) {
      handleFailureAlert("Network error: " + error.message);
    }
  };

  return (
    <Box>
      {/* Stats Section */}
      <Flex
        gap={{ base: "10px", md: "20px" }}
        mb="20px"
        flexWrap="wrap"
        px="0px"
      >
        <Card p="15px 20px" borderRadius="8px" flex="1" minW="150px">
          <Text fontSize="sm" color="gray.500">Total Keywords</Text>
          <Text fontSize="2xl" fontWeight="bold" color={textColor}>{uniqueKeywords.length}</Text>
        </Card>
        <Card p="15px 20px" borderRadius="8px" flex="1" minW="150px">
          <Text fontSize="sm" color="gray.500">Search Terms</Text>
          <Text fontSize="2xl" fontWeight="bold" color={textColor}>{keywords.length}</Text>
        </Card>
        <Card p="15px 20px" borderRadius="8px" flex="1" minW="150px">
          <Text fontSize="sm" color="gray.500">Selected</Text>
          <Text fontSize="2xl" fontWeight="bold" color="green.500">{getAllSelectedPstIds().length}</Text>
        </Card>
      </Flex>

      {/* Main Table Card */}
      <Card
        direction="column"
        w="100%"
        px="0px"
        overflowX={{ sm: "scroll", lg: "hidden" }}
        mb="20px"
      >
        <Flex px="25px" justify="space-between" align="center" gap="10px" pt="5px">
          <SearchBar
            m="10px"
            borderRadius="30px"
            onChange={(e) => handleSearch(e.target.value)}
          />
          {isAdmin && (
            <Flex px="25px" justify="space-between" align="center" gap="10px">
              <Button
                variant="action"
                ml="5px"
                onClick={() => handleSendDataForAll("M")}
              >
                Run Main Search
              </Button>
            </Flex>
          )}
        </Flex>
        <Table variant="simple" color="gray.500" mb="24px" style={{ tableLayout: "fixed" }}>
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor}>
                {isAdmin && (
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    <Checkbox
                      isChecked={keywords?.length === getAllSelectedPstIds().length}
                      onChange={() => {
                        if (keywords?.length === getAllSelectedPstIds().length) {
                          setSelectedSearchTerms({});
                        } else {
                          const allTerms = {};
                          Object.keys(groupedByIdKeywords).forEach((keywordId) => {
                            allTerms[keywordId] = groupedByIdKeywords[
                              keywordId
                            ].flatMap((term) => term.pst_id);
                          });
                          setSelectedSearchTerms(allTerms);
                        }
                      }}
                    />
                  </Flex>
                )}
              </Th>
              {headings.map((column, index) => (
                <Th pe="10px" key={index} borderColor={borderColor}>
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column}
                  </Flex>
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {uniqueKeywords?.map((row, index) => {
              return (
                <>
                  <Tr key={index}>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      {isAdmin && (
                        <Flex align="center">
                          <Text color={textColor} fontSize="md" fontWeight="700">
                            <Checkbox
                              isChecked={
                                selectedSearchTerms[row.keyword_id]?.length ===
                                (groupedByIdKeywords[row.keyword_id]?.length || 0)
                              }
                              onChange={() => handleKeywordCheck(row)}
                            />
                          </Text>
                        </Flex>
                      )}
                    </Td>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                      textAlign="center"
                    >
                      <Flex align="center">
                        <Text
                          color={textColor}
                          fontSize="md"
                          fontWeight="700"
                          align="center"
                        >
                          {index + 1}
                        </Text>
                      </Flex>
                    </Td>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      <Flex align="center">
                        <Text color={textColor} fontSize="md" fontWeight="700">
                          {row.keyword}
                        </Text>
                      </Flex>
                    </Td>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      <Flex align="center">
                        <Text color={textColor} fontSize="md" fontWeight="700">
                          {row.manufacturer}
                        </Text>
                      </Flex>
                    </Td>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      <Flex align="center">
                        <Text color={textColor} fontSize="md" fontWeight="700">
                          {row.brand}
                        </Text>
                      </Flex>
                    </Td>
                    {!editMode[row.keyword_id] ? (
                      <Td
                        fontSize={{ sm: "14px" }}
                        borderColor="transparent"
                      >
                        <Flex align="center">
                          <HandlePlatformsRender
                            platforms={row.platforms}
                            row={row}
                          />
                        </Flex>
                      </Td>
                    ) : (
                      <Td>
                        <Stack pl={6} mt={1} spacing={1}>
                          <Checkbox
                            isChecked={
                              editSelectedPlatforms[row.keyword_id]?.length ===
                              platforms.length
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                const allPlatformIds = platforms.map(
                                  (platform) => platform.id
                                );
                                setEditSelectedPlatforms({
                                  ...editSelectedPlatforms,
                                  [row.keyword_id]: allPlatformIds,
                                });
                              } else {
                                setEditSelectedPlatforms({
                                  ...editSelectedPlatforms,
                                  [row.keyword_id]: [],
                                });
                              }
                            }}
                          >
                            ALL
                          </Checkbox>
                          {platforms.map((platform, index) => (
                            <Checkbox
                              key={index}
                              isChecked={editSelectedPlatforms[
                                row.keyword_id
                              ]?.includes(platform.id)}
                              onChange={(e) => {
                                const current =
                                  editSelectedPlatforms[row.keyword_id] || [];
                                if (e.target.checked) {
                                  setEditSelectedPlatforms({
                                    ...editSelectedPlatforms,
                                    [row.keyword_id]: [...current, platform.id],
                                  });
                                } else {
                                  setEditSelectedPlatforms({
                                    ...editSelectedPlatforms,
                                    [row.keyword_id]: current.filter(
                                      (id) => id !== platform.id
                                    ),
                                  });
                                }
                              }}
                            >
                              {platform.platform_name}
                            </Checkbox>
                          ))}
                        </Stack>
                      </Td>
                    )}

                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      {isAdmin && (
                        <Flex align="center">
                          <Button
                            colorScheme="gray"
                            onClick={() => handleDeleteButton(row)}
                          >
                            <Icon as={DeleteIcon} />
                          </Button>
                          {!editMode[row.keyword_id] ? (
                            <Button
                              colorScheme="gray"
                              onClick={() => handleEditButton(row)}
                            >
                              <Icon as={EditIcon} />
                            </Button>
                          ) : (
                            <Button
                              colorScheme="messenger"
                              size="md"
                              onClick={() => handleSaveEdit(row)}
                            >
                              Save
                            </Button>
                          )}
                          <Button
                            colorScheme="gray"
                            onClick={() => handleExpand(row)}
                          >
                            <Icon as={MdExpandMore} />
                          </Button>
                        </Flex>
                      )}
                    </Td>
                  </Tr>
                  {expandedKeyword === row.keyword_id && (
                    <ExpandedComponent
                      keywordId={row.keyword_id}
                      searchTermList={groupedByIdKeywords[row.keyword_id] || []}
                      platforms={platforms}
                      selectedSearchTerms={selectedSearchTerms}
                      onSearchTermCheck={handleSearchTermCheck}
                      onSearchTermSave={handleSearchTermSave}
                      onSuccessAlert={handleSuccessAlert}
                      onFailureAlert={handleFailureAlert}
                      fetchKeywords={fetchKeywords}
                    />
                  )}
                </>
              );
            })}

            {insertKeywords.map((row, index) => {
              return (
                <Tr key={index}>
                  <Td></Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {uniqueKeywords.length + index + 1}
                      </Text>
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {row.keyword}
                      </Text>
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {row.manufacturer}
                      </Text>
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {row.brand}
                      </Text>
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "150px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      {row.platformIds.includes(1) && (
                        <Image
                          boxSize="15px"
                          objectFit="cover"
                          src={Amazon}
                          alt="Amazon Icon"
                          mr="5px"
                        />
                      )}
                      {row.platformIds.includes(2) && (
                        <Image
                          boxSize="19px"
                          objectFit="cover"
                          src={Flipkart}
                          alt="Flipkart Icon"
                          mr="5px"
                        />
                      )}
                      {row.platformIds.includes(3) && (
                        <Image
                          boxSize="15px"
                          objectFit="cover"
                          src={Meesho}
                          alt="Meesho Icon"
                          mr="2px"
                        />
                      )}
                      {row.platformIds.includes(7) && (
                        <Image
                          boxSize="15px"
                          objectFit="cover"
                          src={freeup}
                          alt="Freeup Icon"
                          mr="2px"
                        />
                      )}
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "150px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Button
                        colorScheme="gray"
                        onClick={() => handleNewDeleteButton(row)}
                      >
                        <Icon as={DeleteIcon} />
                      </Button>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Card>

      {/* Add New Keyword Card - SEPARATE COMPONENT */}
      {isAdmin && (
        <Card p="20px" mb="20px">
          <VStack align="stretch" spacing="16px">
            <Heading size="sm" color={textColor}>
              Add New Keyword
            </Heading>

            <HStack spacing="12px" align="flex-end" flexWrap="wrap">
              <Box flex="1" minW="200px">
                <Text fontSize="sm" fontWeight="600" mb="6px" color="gray.600">
                  Keyword Name
                </Text>
                <Input
                  onChange={(e) => setInputKeyword(e.target.value)}
                  placeholder="Enter keyword"
                  size="md"
                  borderColor={
                    inputKeyword === "" && inputError ? "red.500" : undefined
                  }
                  value={inputKeyword}
                />
              </Box>

              <Box flex="1" minW="200px">
                <Text fontSize="sm" fontWeight="600" mb="6px" color="gray.600">
                  Manufacturer
                </Text>
                <Input
                  onChange={(e) => setInputManu(e.target.value)}
                  placeholder="Enter manufacturer"
                  size="md"
                  borderColor={
                    inputManu === "" && inputError ? "red.500" : undefined
                  }
                  value={inputManu}
                />
              </Box>

              <Box flex="1" minW="200px">
                <Text fontSize="sm" fontWeight="600" mb="6px" color="gray.600">
                  Brand
                </Text>
                <Input
                  onChange={(e) => setInputBrand(e.target.value)}
                  placeholder="Enter brand"
                  size="md"
                  borderColor={
                    inputBrand === "" && inputError ? "red.500" : undefined
                  }
                  value={inputBrand}
                />
              </Box>

              <Button
                colorScheme="green"
                onClick={handleTempInsertKeyword}
                size="md"
              >
                Add +
              </Button>
            </HStack>

            {inputError && (
              <Alert status="error" borderRadius="6px">
                <AlertIcon />
                Please fill all fields and select platforms
              </Alert>
            )}

            <Divider />

            <Flex align={"center"} justify={"space-between"}>
              <Text fontSize="sm" fontWeight="600" mb="12px" color="gray.600">
                Select Platforms:
              </Text>
              <HStack spacing="12px" flexWrap="wrap">
                {/* "ALL" Toggle Button */}
                <Box
                  as="button"
                  px="1.5"
                  py="2"
                  borderRadius="100%"
                  fontSize="xs"
                  fontWeight="bold"
                  border="1px solid"
                  transition="all 0.2s"
                  borderColor={selectedPlatforms.length === platforms.length ? "blue.500" : "gray.200"}
                  bg={selectedPlatforms.length === platforms.length ? "blue.50" : "white"}
                  color={selectedPlatforms.length === platforms.length ? "blue.600" : "gray.500"}
                  _hover={{ borderColor: "blue.300" }}
                  onClick={() => {
                    if (selectedPlatforms.length === platforms.length) {
                      setSelectedPlatforms([]);
                    } else {
                      setSelectedPlatforms(platforms.map((p) => p.id));
                    }
                  }}
                >
                  ALL
                </Box>

                {/* Individual Icon Toggles */}
                {platforms.map((platform, index) => {
                  const isSelected = selectedPlatforms.includes(platform.id);
                  return (
                    <Box
                      key={index}
                      as="button"
                      onClick={() => {
                        if (isSelected) {
                          setSelectedPlatforms(selectedPlatforms.filter((id) => id !== platform.id));
                        } else {
                          setSelectedPlatforms([...selectedPlatforms, platform.id]);
                        }
                      }}
                      p="6px"
                      borderRadius="100%"
                      border="2px solid"
                      transition="all 0.2s"
                      // Changes border and background based on selection
                      borderColor={isSelected ? "blue.500" : "transparent"}
                      bg={isSelected ? "blue.50" : "gray.50"}
                      _hover={{ borderColor: isSelected ? "blue.600" : "gray.300" }}
                      title={platform.platform_name}
                    >
                      <Image
                        src={getPlatformIcon(platform.id)||`https://www.google.com/s2/favicons?domain=${platform.platform_name}&sz=128` || `https://www.${platform.platform_name}/favicon.ico`}
                        boxSize="20px"
                        objectFit="contain"
                        rounded={5}
                        alt={`Platform ${platform.platform_name}`}
                        // Makes icon color pop when selected, grayscale when not
                        filter={isSelected ? "none" : "grayscale(100%)"}
                        opacity={isSelected ? 1 : 0.5}
                      />
                    </Box>
                  );
                })}
              </HStack>
            </Flex>

            <Button
              colorScheme="green"
              size="lg"
              onClick={handleConfirm}
              isDisabled={insertKeywords.length === 0}
            >
              Save All Changes
            </Button>
          </VStack>
        </Card>
      )}

      {/* Alerts */}
      <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
        {successAlert !== "" && (
          <Alert status="success" variant="left-accent" w="40vw">
            <AlertIcon />
            {successAlert}
          </Alert>
        )}
        {failureAlert !== "" && (
          <Alert status="error" variant="left-accent" w="40vw">
            <AlertIcon />
            {failureAlert}
          </Alert>
        )}
      </Stack>
    </Box>
  );
}
